module.exports = __webpack_public_path__ + "static/media/project1_2.3e30c12a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/project1_2.png
// module id = 358
// module chunks = 0